// extracted by mini-css-extract-plugin
export default {"fade":"DownloadModal_fade__xnTRQ","show":"DownloadModal_show__KryRz"};